const addDaysToDate = (date: Date, nb: number): Date => {
    const newDate = new Date(date).setDate(date.getDate() + nb);
    return new Date(newDate);
};

const removeDaysToDate = (date: Date, nb: number): Date => {
    const newDate = new Date(date).setDate(date.getDate() - nb);
    return new Date(newDate);
};

const getDaysByLocale = (locale: string): string[] => {
    const days: any = {
        fr: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    }

    return days[locale];
}

const daysInMonth = (month: number, year: number) => {
    return new Date(year, month, 0).getDate();
};

//Return true if dates are the same
const compareDates = (date1: Date, date2: Date) => {
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();
    const day1 = date1.getDate();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();
    const day2 = date2.getDate();

    return year1 === year2 && month1 === month2 && day1 === day2;
};

export const isToday = (someDate: Date) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
}

export { addDaysToDate, removeDaysToDate, getDaysByLocale, daysInMonth, compareDates }